/* eslint-disable react-hooks/exhaustive-deps */
import { Autocomplete, Box, Card, CircularProgress, FormControl, FormControlLabel, Grid, InputLabel, OutlinedInput, styled, Switch, TextField, Typography } from "@mui/material"
import { ActionStage, CurrencyJSON, ItemStatus, Scope } from "../../../../../common/const";
import { useEffect, useState } from "react";
import { showNotification } from "../../../../../common/Notification/ToastifyNotification";
import { apiRequest } from "../../../../../common/common";
import moment from "moment";
import { useSelector } from "react-redux";

const DemoTypography = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: 13
}));

const DemoTypo = styled(Typography)(({ theme }) => ({
  fontSize: 13
}));

const DefaultTypo = styled(Typography)(({ theme }) => ({
  color: 'gray',
  fontSize: 10
}));

const DefaultTypo1 = styled(Typography)(({ theme }) => ({
  color: 'red',
  fontSize: 10
}));

const ItemInformation = ({
  itemData,
  projectData,
  items,
  setItems
}) => {
  const { user } = useSelector((state) => state.users);
  const [vendorData, setVendorData] = useState([]);
  const [vendorPage, setVendorPage] = useState(1);
  const [isVendorAvailable, setIsVendorAvailable] = useState(true);
  const [vendorLoading, setVendorLoading] = useState(false);
  const [manufacturerData, setManufacturerData] = useState([]);
  const [manufacturerLoading, setManufacturerLoading] = useState(false);
  const [modelLoading, setModelLoading] = useState(false);
  const [modelData, setModelData] = useState([]);
  const [phaseData, setPhaseData] = useState([]);
  const [phaseLoading, setPhaseLoading] = useState(false);
  const [costData, setCostData] = useState([]);
  const [costLoading, setCostLoading] = useState([]);
  const [bidGroupData, setBidGroupData] = useState([]);
  const [bidLoading, setBidLoading] = useState(false);

  const getCostCentre = async () => {
    try {
      setCostLoading(true);
      const url = [
        `/department/cost-center?projectId=${projectData?.project_id}`,
        `pageNo=1`,
        `pageSize=100`,
      ].filter(Boolean).join('&');
      const response = await apiRequest('get', `${url}`);
      const { data } = response.data;
      setCostData(data);
      setCostLoading(false);
    } catch (error) {
      setCostLoading(false);
      showNotification(error?.response?.data.error || error.message, 'error');
    }
  }

  const getPhase = async () => {
    try {
      setPhaseLoading(true);
      const url = [
        `/department/phases?projectId=${projectData?.project_id}`,
        `pageNo=1`,
        `pageSize=100`,
      ].filter(Boolean).join('&');
      const response = await apiRequest('get', `${url}`);
      const { data } = response.data;
      setPhaseData(data);
      setPhaseLoading(false);
    } catch (error) {
      setPhaseLoading(false);
      showNotification(error?.response?.data.error || error.message, 'error');
    }
  }

  const getBidGroup = async () => {
    try {
      setBidLoading(true);
      const response = await apiRequest('get', `/bid-group?organizationId=${user?.organization?.organization_id}`);
      const { data } = response.data;
      setBidGroupData(data);
      setBidLoading(false);
    } catch (error) {
      setBidLoading(false);
      showNotification(error?.response?.data.error || error.message, 'error');
    }
  }

  useEffect(() => {
    if (projectData?.project_id) {
      getPhase();
      getCostCentre();
      getBidGroup();
    }
  }, [projectData]);

  const getManufacturer = async (searchText) => {
    try {
      setManufacturerLoading(true);
      const response = await apiRequest('get', `/product/product-by-category?category=${itemData?.product?.category_id}&subCategory=${itemData?.product?.sub_category_id}&${searchText ? `searchText=${searchText}` : ''}`);
      const { data } = response.data;
      if (data?.length > 0) {
        setManufacturerData(data);
        setManufacturerLoading(false);
      } else {
        setManufacturerLoading(false);
      }
    } catch (error) {
      setManufacturerLoading(false);
      showNotification(error?.response?.data.error || error.message, 'error');
    }
  }

  const getVendorData = async (pageNo, searchText) => {
    try {
      setVendorLoading(true);
      const response = await apiRequest('get', `/product-provider?type=vender&pageNo=${pageNo}&pageSize=100&${searchText ? `searchText=${searchText}` : ''}`);
      const { data } = response.data;
      if (data?.length > 0) {
        setIsVendorAvailable(true);
        const array = [...vendorData, ...data];
        const uniqueArray = [
          ...new Set(
            array.map((item) => JSON.stringify(item)),
          ),
        ].map((item) => JSON.parse(item));
        setVendorData(uniqueArray);
        setVendorLoading(false);
      } else {
        setIsVendorAvailable(false);
        setVendorLoading(false);
      }
    } catch (error) {
      setVendorLoading(false);
      showNotification(error?.response?.data.error || error.message, 'error');
    }
  }

  useEffect(() => {
    if (itemData?.product?.category_id && itemData?.product?.sub_category_id) {
      getVendorData(vendorPage);
      getManufacturer();
    }
  }, [itemData]);

  const getModelData = async (searchText) => {
    try {
      setModelLoading(true);
      const response = await apiRequest('get', `/product/product-by-category?category=${itemData?.product?.category_id}&subCategory=${itemData?.product?.sub_category_id}&manufacturer=${items?.manufacturer_id}&${searchText ? `searchText=${searchText}` : ''}`);
      const { data } = response.data;
      if (data?.length > 0) {
        setModelData(data);
        setModelLoading(false);
      } else {
        setModelLoading(false);
      }
    } catch (error) {
      setModelLoading(false);
      showNotification(error?.response?.data.error || error.message, 'error');
    }
  }

  useEffect(() => {
    if (items?.manufacturer_id) {
      getModelData();
    }
  }, [items?.manufacturer_id])

  const loadNextVendor = async (event) => {
    const listBoxNode = event.currentTarget;
    const numberOfPages = vendorPage + 1;
    const position = listBoxNode.scrollTop + listBoxNode.clientHeight;
    if (listBoxNode.scrollHeight - position <= 1 && isVendorAvailable) {
      setVendorPage(numberOfPages);
      await getVendorData(numberOfPages);
    }
  };

  return (
    <>
      <Card sx={{ p: 1, marginBottom: 1 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={6} lg={1}>
            <img
              src={itemData?.product?.images?.[0]?.sortUrl ? `${process.env.REACT_APP_IMAGEURL}bbn=${itemData?.product?.images?.[0]?.sortUrl}&uid=${user?.user_id}` : 'https://dummyimage.com/100x100/000/fff'}
              style={{ width: 100, height: '80px', imageRendering: 'auto' }}
              alt="big img"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={11}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box ml={2}>
                <Typography variant="body1" style={{ fontWeight: 'bold' }}>{items?.product_data?.model ? items?.product_data?.model : 'UnSpecified'}</Typography>
                <DemoTypography variant="body2">{`${itemData?.product?.category?.name || ''}, ${itemData?.product?.["sub_category"]?.name || ''}`}</DemoTypography>
              </Box>
              <Box display="flex" alignItems="center" gap={1}>
                <Typography variant="body1" style={{ fontWeight: 600 }}>(1 each)</Typography>
                <Typography variant="body1" style={{ fontWeight: 'bold' }}>{`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${items?.unit_price ? Intl.NumberFormat('en-IN').format(items?.unit_price) : 0}`}</Typography>
              </Box>
            </Box>
            <Grid container spacing={2} ml={0.2}>
              <Grid item sm={12} md={3}>
                <Box display="flex" alignItems="center" gap={1}>
                  <DemoTypo variant="body2">Numeric ID :</DemoTypo>
                  <DemoTypography variant="body2">
                    {itemData?.product?.is_customer_product ?
                      `C-${itemData?.product?.alternate_id}`
                      :
                      itemData?.product?.["numaric_sku"] ? `${itemData?.product?.category?.["sku_no"] || ''}${itemData?.product?.sub_category?.["sku_no"] || ''}-${String(itemData?.product?.["numaric_sku"]).padStart(3, '0')}` :
                        `${itemData?.product?.category?.["sku_no"] || ''}${itemData?.product?.sub_category?.["sku_no"] || ''}-${String(0).padStart(3, '0')}`
                    }
                  </DemoTypography>
                </Box>
                <Box display="flex" alignItems="center" gap={1}>
                  <DemoTypo variant="body2">Alphanumeric ID :</DemoTypo>
                  <DemoTypography variant="body2">
                    {itemData?.product?.is_customer_product ?
                      `C-${itemData?.product?.alternate_id}`
                      : itemData?.product?.["numaric_sku"] ? `${itemData?.product?.category?.["prefix"] || ''}${itemData?.product?.sub_category?.["prefix"] || ''}-${String(itemData?.product?.["numaric_sku"]).padStart(3, '0')}` :
                        `${itemData?.product?.category?.["prefix"] || ''}${itemData?.product?.sub_category?.["prefix"] || ''}-${String(0).padStart(3, '0')}`
                    }
                  </DemoTypography>
                </Box>
              </Grid>
              <Grid item sm={12} md={6}>
                <Box display="flex" alignItems="center" gap={1}>
                  <DemoTypo variant="body2">Manufacturer:</DemoTypo>
                  <DemoTypography variant="body2">{items?.manufacturer?.name || '--'}</DemoTypography>
                </Box>
                <Box display="flex" alignItems="center" gap={1}>
                  <DemoTypo variant="body2">Vendor :</DemoTypo>
                  <DemoTypography variant="body2">{items?.product_data?.vendor?.name || '--'}</DemoTypography>
                </Box>
              </Grid>
              <Grid item sm={12} md={3}>
                <Box display="flex" alignItems="center" gap={1}>
                  <DemoTypo variant="body2">Catalog #:</DemoTypo>
                  <DemoTypography variant="body2">{items?.product_data?.catalog || '--'}</DemoTypography>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Card>
      <Typography variant="body1" sx={{ fontWeight: 600 }}>Item Details</Typography>
      <Typography variant="body2" sx={{ fontSize: 12 }}>Configure the details of this Item</Typography>
      <Grid container spacing={2} mt={0.3}>
        <Grid item sm={12} md={6} lg={3}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel htmlFor="standard-adornment-password">Description</InputLabel>
            <OutlinedInput
              label="Description"
              id="standard-adornment-password"
              type='text'
              disabled
              value={`${itemData?.product?.category?.name || ''}, ${itemData?.product?.["sub_category"]?.name || ''}`}
            />
          </FormControl>
        </Grid>
        <Grid item sm={12} md={6} lg={3}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel htmlFor="standard-adornment-password">Alternate Description</InputLabel>
            <OutlinedInput
              label="Alternate Description"
              id="standard-adornment-password"
              type='text'
              value={items?.alternate_description || ''}
              onChange={(e) => {
                setItems((prevData) => ({
                  ...prevData,
                  alternate_description: e.target.value
                }));
              }}
            />
          </FormControl>
        </Grid>
        <Grid item sm={12} md={6} lg={3}>
          <Autocomplete
            value={Scope.find((c) => c.value === items?.scope) || null}
            id="combo-box-demo"
            size="small"
            fullWidth
            options={Scope}
            clearIcon={null}
            getOptionLabel={(option) => option?.name}
            onChange={(event, newValue) => {
              setItems((prevData) => ({
                ...prevData,
                scope: newValue?.value || null,
              }));
            }}
            renderInput={(params) => <TextField fullWidth {...params} label="Scope *" name="Scope *" variant="outlined" />}
          />
        </Grid>
        <Grid item sm={12} md={6} lg={3}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel htmlFor="standard-adornment-password">Custom ID1</InputLabel>
            <OutlinedInput
              label="Custom ID1"
              id="standard-adornment-password"
              type='text'
              value={items?.product_data?.custom_id_1 || ''}
              onChange={(e) => {
                setItems((prevData) => ({
                  ...prevData,
                  product_data: {
                    ...prevData?.product_data,
                    custom_id_1: e.target.value
                  }
                }));
              }}
            />
          </FormControl>
        </Grid>
        <Grid item sm={12} md={6} lg={3}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel htmlFor="standard-adornment-password">Custom ID2</InputLabel>
            <OutlinedInput
              label="Custom ID2"
              id="standard-adornment-password"
              type='text'
              value={items?.product_data?.custom_id_2 || ''}
              onChange={(e) => {
                setItems((prevData) => ({
                  ...prevData,
                  product_data: {
                    ...prevData?.product_data,
                    custom_id_2: e.target.value
                  }
                }));
              }}
            />
          </FormControl>
        </Grid>
        <Grid item sm={12} md={6} lg={3}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel htmlFor="standard-adornment-password">Alt ID</InputLabel>
            <OutlinedInput
              label="Alt ID"
              id="standard-adornment-password"
              type='text'
              value={items?.product_data?.alternate_id || ''}
              onChange={(e) => {
                setItems((prevData) => ({
                  ...prevData,
                  product_data: {
                    ...prevData?.product_data,
                    alternate_id: e.target.value
                  }
                }));
              }}
            />
          </FormControl>
        </Grid>
        <Grid item sm={12} md={6} lg={3}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel htmlFor="standard-adornment-password">Govt ID</InputLabel>
            <OutlinedInput
              label="Govt ID"
              id="standard-adornment-password"
              type='text'
              value={items?.product_data?.govt_id || ''}
              onChange={(e) => {
                setItems((prevData) => ({
                  ...prevData,
                  product_data: {
                    ...prevData?.product_data,
                    govt_id: e.target.value
                  }
                }));
              }}
            />
          </FormControl>
        </Grid>
        <Grid item sm={12} md={6} lg={3}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel htmlFor="standard-adornment-password">Inventory ID</InputLabel>
            <OutlinedInput
              label="Inventory ID"
              id="standard-adornment-password"
              type='text'
              value={items?.product_data?.inventory_id || ''}
              onChange={(e) => {
                setItems((prevData) => ({
                  ...prevData,
                  product_data: {
                    ...prevData?.product_data,
                    inventory_id: e.target.value
                  }
                }));
              }}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <Autocomplete
            value={manufacturerData.find((c) => c.manufacturer?.product_provider_id === items?.manufacturer_id) || null}
            id="combo-box-demo"
            size="small"
            fullWidth
            clearIcon={null}
            options={manufacturerData}
            getOptionLabel={(option) => option?.manufacturer?.name}
            onChange={(event, newValue) => {
              setItems((prevData) => ({
                ...prevData,
                manufacturer_id: newValue?.manufacturer?.product_provider_id || null,
                manufacturer: {
                  name: newValue?.manufacturer?.name
                }
              }));
            }}
            onInputChange={(e) => {
              if (e) {
                if (e?.target?.value?.length >= 1) {
                  setManufacturerData([]);
                  getManufacturer(e?.target?.value);
                }
              }
            }}
            renderInput={(params) =>
              <TextField
                fullWidth
                {...params}
                label="Manufacturer"
                name="Manufacturer"
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {manufacturerLoading ? <CircularProgress color="primary" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <Autocomplete
            value={modelData.find((c) => c.model === items?.product_data?.model) || null}
            id="combo-box-demo"
            size="small"
            fullWidth
            clearIcon={null}
            options={modelData}
            getOptionLabel={(option) => option?.model}
            onChange={(event, newValue) => {
              setItems((prevData) => ({
                ...prevData,
                product_data: {
                  model: newValue?.model
                },
                product_id: newValue?.product_id
              }));
            }}
            onInputChange={(e) => {
              if (e) {
                if (e?.target?.value?.length >= 1) {
                  setModelData([]);
                  getModelData(e?.target?.value);
                }
              }
            }}
            renderInput={(params) =>
              <TextField
                fullWidth
                {...params}
                label="Model"
                name="Model"
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {modelLoading ? <CircularProgress color="primary" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />}
          />
        </Grid>
        <Grid item sm={12} md={6} lg={3}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel htmlFor="standard-adornment-password">Catalog #</InputLabel>
            <OutlinedInput
              label="Catalog #"
              id="standard-adornment-password"
              type='text'
              value={items?.product_data?.catalog || ''}
              onChange={(e) => {
                setItems((prevData) => ({
                  ...prevData,
                  product_data: {
                    ...prevData?.product_data,
                    catalog: e.target.value
                  }
                }));
              }}
            />
          </FormControl>
          {items?.product_data?.catalog !== itemData?.product?.catalog && (
            <Box display="flex" alignItems="center">
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{itemData?.product?.catalog || '--'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <Autocomplete
            value={vendorData.find((c) => c.product_provider_id === items?.product_data?.vendor_id) || null}
            id="combo-box-demo"
            size="small"
            fullWidth
            options={vendorData}
            getOptionLabel={(option) => option?.name}
            ListboxProps={{
              onScroll: (event) => loadNextVendor(event),
            }}
            onChange={(event, newValue) => {
              setItems((prevData) => ({
                ...prevData,
                product_data: {
                  ...prevData.product_data,
                  vendor_id: newValue?.product_provider_id || null,
                  vendor: {
                    name: newValue?.name || null
                  }
                }
              }));
            }}
            onInputChange={(e) => {
              if (e) {
                if (e?.target?.value?.length >= 1) {
                  setVendorData([]);
                  setVendorPage(1);
                  getVendorData(1, e?.target?.value);
                }
              }
            }}
            renderInput={(params) =>
              <TextField
                fullWidth
                {...params}
                label="Vendor"
                name="Vendor"
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {vendorLoading ? <CircularProgress color="primary" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />}
          />
          {items?.product_data?.vendor_id !== itemData?.product?.vendor?.product_provider_id && (
            <Box display="flex" alignItems="center">
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{vendorData.find((a) => a.product_provider_id === itemData?.product?.vendor?.product_provider_id)?.name || '--'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <Autocomplete
            value={ItemStatus.find((c) => c.value === items?.status) || null}
            id="combo-box-demo"
            size="small"
            fullWidth
            options={ItemStatus}
            clearIcon={null}
            getOptionLabel={(option) => option?.name}
            onChange={(event, newValue) => {
              setItems((prevData) => ({
                ...prevData,
                status: newValue?.value || null,
                unit_price: newValue?.value === 'existing' ? 0 : itemData?.product?.list_price
              }));
            }}
            renderInput={(params) => <TextField fullWidth {...params} label="Status" name="Status" variant="outlined" />}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <Autocomplete
            value={ActionStage.find((c) => c.value === items?.stage) || null}
            id="combo-box-demo"
            size="small"
            fullWidth
            clearIcon={null}
            options={ActionStage}
            getOptionLabel={(option) => option?.name}
            onChange={(event, newValue) => {
              setItems((prevData) => ({
                ...prevData,
                stage: newValue?.value || null,
              }));
            }}
            renderInput={(params) => <TextField fullWidth {...params} label="Action Stage" name="Action Stage" variant="outlined" />}
          />
        </Grid>
        <Grid item sm={12} md={6} lg={3}>
          <Autocomplete
            value={bidGroupData?.find((c) => c.bid_group_id === items?.bid_group_id) || null}
            id="combo-box-demo"
            size="small"
            fullWidth
            clearIcon={null}
            options={bidGroupData}
            getOptionLabel={(option) => option?.name}
            onChange={(event, newValue) => {
              setItems((prevData) => ({
                ...prevData,
                bid_group_id: newValue?.bid_group_id || null,
              }));
            }}
            renderInput={(params) =>
              <TextField
                fullWidth {...params}
                label="Bid Group"
                name="Bid Group"
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {bidLoading ? <CircularProgress color="primary" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />}
          />
        </Grid>
        <Grid item sm={12} md={6} lg={3}>
          <Autocomplete
            value={phaseData.find((c) => c.phase_id === items?.phase_id) || null}
            id="combo-box-demo"
            size="small"
            fullWidth
            options={phaseData}
            getOptionLabel={(option) => option.phase_name}
            onChange={(event, newValue) => {
              setItems((prevData) => ({
                ...prevData,
                phase_id: newValue?.phase_id || null,
                phase_date: newValue?.phase_date ? moment(newValue?.phase_date).format('YYYY-MM-DD') : null
              }));
            }}
            renderInput={(params) =>
              <TextField
                fullWidth
                {...params}
                label="Area/Phase Name"
                name="Area/Phase Name"
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {phaseLoading ? <CircularProgress color="primary" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />}
          />
        </Grid>
        <Grid item sm={12} md={6} lg={3}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel htmlFor="standard-adornment-password" shrink={items?.phase_date === null || items?.phase_date === '' || items?.phase_date}>Area/Phase Date</InputLabel>
            <OutlinedInput
              label="Area/Phase Date"
              id="Area/Phase Date"
              type='date'
              value={items?.phase_date || ''}
              onChange={(e) => {
                setItems((prevData) => ({
                  ...prevData,
                  phase_date: e.target.value || null,
                }));
              }}
            />
          </FormControl>
        </Grid>
        <Grid item sm={12} md={6} lg={3}>
          <Autocomplete
            value={costData.find((c) => c.cost_centre_id === items?.cost_centre_id) || null}
            id="combo-box-demo"
            size="small"
            fullWidth
            options={costData}
            getOptionLabel={(option) => option.cost_centre_name}
            onChange={(event, newValue) => {
              setItems((prevData) => ({
                ...prevData,
                cost_centre_id: newValue?.cost_centre_id || null,
              }));
            }}
            renderInput={(params) =>
              <TextField
                fullWidth
                {...params}
                label="Cost Centre"
                name="Cost Centre"
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {costLoading ? <CircularProgress color="primary" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />}
          />
        </Grid>
        <Grid item sm={12} md={6} lg={3}>
          <FormControlLabel control={
            <Switch
              checked={items?.product_data?.from_project}
              onChange={(e) => {
                setItems((prevData) => ({
                  ...prevData,
                  product_data: {
                    ...prevData.product_data,
                    from_project: e.target.checked,
                    need_by_date: moment(projectData?.target_occupation).format('YYYY-MM-DDThh:mm:ssZ')
                  }
                }))
              }}
            />}
            sx={{ '& .MuiFormControlLabel-label': { fontSize: '12px' } }}
            label="Need by date is auto-assigned from the Room or Project"
          />
        </Grid>
        <Grid item sm={12} md={6} lg={3}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel htmlFor="standard-adornment-password" shrink={items?.need_by_date === null || items?.need_by_date === '' || items?.need_by_date}>Need By Date</InputLabel>
            <OutlinedInput
              label="Need By"
              id="need by"
              type='date'
              disabled={items?.product_data?.from_project}
              value={items?.need_by_date || ''}
              onChange={(e) => {
                setItems((prevData) => ({
                  ...prevData,
                  need_by_date: e.target.value || null,
                }));
              }}
            />
          </FormControl>
        </Grid>
        <Grid item sm={12} md={6} lg={6}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel htmlFor="standard-adornment-password">Item Notes</InputLabel>
            <OutlinedInput
              label="Item Notes"
              id="standard-adornment-password"
              type='text'
              multiline
              minRows={3}
              maxRows={4}
              value={items?.notes || ''}
              onChange={(e) => {
                setItems((prevData) => ({
                  ...prevData,
                  notes: e.target.value
                }));
              }}
            />
          </FormControl>
        </Grid>
      </Grid>
    </>
  )
}

export default ItemInformation;